/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import {
  URL_TYPES_RECONNAISSANCE,
  TYPE_REGISTRE_BY_TYPE_ACTE,
} from '@/constants';

import InformationsActe from './InformationsActe';
import InformationsEvenementReconnaissance from './InformationsEvenementReconnaissance';

/**
 * Étape 1 « Acte » de l'acte de reconnaissance : 2 blocs (décision produit 2)
 * — `INFORMATIONS DE L'ACTE` (réutilisée, paramétrée sur le référentiel
 * `ec_typrec`), `INFORMATIONS SUR L'ÉVÉNEMENT` (nouveau). `INFORMATIONS SUR
 * L'ENFANT` est dans sa propre étape (`StepEnfant`), avant celle des parents.
 *
 * Assembleur séparé de `StepActeNaissance` plutôt qu'un `if` interne à
 * `StepActeNaissance` : le choix « quel bloc pour quel type d'acte » est déjà
 * centralisé dans `assistantConfig.tsx`, le dupliquer ici créerait deux
 * sources de vérité. Seul le `<div>` de layout est répété ; aucun champ de
 * formulaire n'est dupliqué (tous les blocs sont réutilisés).
 */
const StepActeReconnaissance = () => {
  const { data, onChange, errors } = React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Acte] ?? {};

  return (
    <div
      className="assistant-step-acte-reconnaissance"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsActe
        data={data}
        errors={errorsStep}
        onChange={onChange}
        urlSousTypesActe={URL_TYPES_RECONNAISSANCE}
        typeRegistre={TYPE_REGISTRE_BY_TYPE_ACTE.reconnaissance}
        labelSousTypeActe="Sous type de reconnaissance"
      />
      <InformationsEvenementReconnaissance
        data={data}
        errors={errorsStep}
        onChange={onChange}
      />
    </div>
  );
};

export default StepActeReconnaissance;
